import _ from 'lodash'
import { reducerWithInitialState } from 'typescript-fsa-reducers'
import { SubControl } from '../../types'
import * as actions from './actions'

export type State = { [id: number]: SubControl }

export const initialState: State = {}

export default reducerWithInitialState(initialState).case(
	actions.registerSubControls,
	(state, objects) => {
		return { ...state, ..._.keyBy(objects, 'id') }
	},
)
